import { DefaultTheme } from 'styled-components';

import { breakpoints } from './breakpoints';
import { darkColors } from './colors';
import { typography } from './typography';

export const Theme: DefaultTheme = {
    colors: darkColors,
    typography,
    breakpoints,
    isMobile: false,
    isDark: true,
};
